<template>
  <div class="financial-statements-hk">
    <components
      :is="currentStatement"
      :data="tableData"
      :reportKindMap="reportKindMap"
      :css="css"
      :formatAParams="formatAParams"
      :mainDataStyle="mainDataStyle"
    ></components>
  </div>
</template>

<script>
import BalanceStatement0 from './BalanceStatement-0.vue'
import BalanceStatement1 from './BalanceStatement-1.vue'
import BalanceStatement2 from './BalanceStatement-2.vue'
const statementComponents = {
  0: BalanceStatement0,
  1: BalanceStatement1,
  2: BalanceStatement2,
  3: BalanceStatement0
}
export default {
  props: ['css', 'mainDataStyle'],
  data() {
    return {
      tableData: [],
      reportKindMap: {
        0: '非金融',
        1: '银行',
        2: '保险',
        3: '非金融'
      }
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    reportKind() {
      return this.tableData[0]?.reportKind
    },
    currentStatement() {
      return statementComponents[this.reportKind]
    }
  },
  created() {
    this.getBalanceStatement()
  },
  methods: {
    // 将A股同义字段统一为港股接口字段名称
    formatAParams(val) {
      if (this.market !== 'hs') return val

      const oldVal = val.replace('YoY', '')

      const newVal = {
        /* 非金融 */
        // 固定资产
        fixedAssets: 'fixedAsset',
        // 投资
        investments: '',
        // 商誉及无形资产
        goodwillIntangibleAssets: '',
        // 其他非流动资产
        otherNonCurrentAssets: 'otherNonCurAssets',
        // 非流动资产总额
        totalNonCurrentAssets: 'totalNonCurAssets',
        // 贸易应收款项
        tradeDebtors: '',
        // 现金及银行结存
        cashAndNearCash: '',
        // 其他流动资产
        otherCurrentAssets: 'otherCurAssets',
        // 流动资产总额
        totalCurrentAssets: 'totalCurAssets',
        // 资产净值
        netAssets: '',
        // 营运资金
        fundsFromOperations: '',
        // 营运资金变动
        changesInWorkCapital: '',
        // 现金总额 TODO 不确定
        totalCash: 'monetaryFund',
        // 净现金/(债项)
        netCash: '',
        // 总资产
        totalAssets: 'totalAsset',
        // 贸易应付款项
        tradeCreditors: '',
        // 短期债项
        shortTermDebt: '',
        // 其他短期负债
        otherCurrentLiabilities: 'otherCurLiab',
        // 流动负债总额
        totalCurrentLiabilities: 'totalCurLiab',
        // 流动资产/(负债)净值
        netCurrentAssets: '',
        // 总资产减流动负债
        totalAssetsLessCurrLiab: '',
        // 长期债项
        longTermDebt: '',
        // 其他非流动负债
        otherNonCurrentLiab: 'otherNonCurLiab',
        // 非流动负债总额
        totalNonCurrentLiab: 'totalNonCurLiab',
        // 总债项
        totalDebt: '',
        // 速动资产
        quickAssets: '',
        // 总负债
        totalLiabilities: 'totalLiab',
        // 股本总额
        totalShareCapital: '',
        // 储备总额
        totalReserves: '',
        // 本公司拥有人应占权益 TODO 不确定
        ownersEquity: 'totalSHEquityParentCom',
        // 永久资本证券 TODO 不确定
        perpetualSecurities: 'sustainableDebt',
        // 非控股权益
        nonControllingInterests: '',
        // 权益总额 TODO 不确定
        totalEquity: 'totalSHEquity',

        /* 银行 不包含上方已出现的字段 */
        // 库存现金及短期资金
        cashAndShortTermFunds: '',
        // 向其他银行托收中之项目
        itemsFromOtherBanks: '',
        // 定期存放银行同业及其他财务机构(资产)
        placingsBankAndFinInstitutions: '',
        // 商业票据
        tradingBills: '',
        // 交易用途资产
        tradingAssets: '',
        // 非交易用途资产
        nonTradingAssets: '',
        // 公平订值之金融资产
        financialAssetsAtFairValue: '',
        // 可供出售之证券
        availableSaleFinancialAssets: '',
        // 衍生工具(资产)
        derivativesAssets: '',
        // 存款证
        certificatesOfDepositHeld: '',
        // 银行同业贷款及垫款
        loansAndAdvancesToBanks: '',
        // 客户贷款及垫款
        loansAndAdvancesToCustomers: '',
        // 金融投资
        financialInvestments: '',
        // 持至到期投资
        heldToMaturityInvestments: '',
        // 联营及合资公司权益
        InterestsEntitiesAssociates: '',
        // 其他资产
        otherAssets: 'otherAsset',
        // 香港纸币流通额 TODO 该字段不合理，此处为A股，但原型图中有该字段
        hkdNotesInCirculation: '',
        // 同业及财务机构存款
        deposits: '',
        // 客户存款
        depositsFromCustomers: 'clientDeposit',
        // 定期存放银行同业及其他财务机构(负债)
        placementsBankAndFinInstitutions: '',
        // 已发行之债务证券 TODO 不确定
        debtsSecuritiesIssued: 'bondPay',
        // 已发行之存款证
        certificatesOfDepositIssued: '',
        // 已发行之可换股债券
        convertibleBondsIssued: '',
        // 已发行之浮息票据
        floatingRateNotesIssued: '',
        // 交易用途负债
        tradingLiabilities: '',
        // 公平订值之金融负债
        financialLiabilitiesAtFairValue: '',
        // 衍生工具(负债)
        derivativesLiabilities: '',
        // 后偿负债
        subordinatedLiabilities: '',
        // 其他负债
        otherLiabilities: '',
        // 资本储备
        capitalReserve: '',
        // 其他储备
        otherReserves: 'fairValueChangeRes',

        /* 保险 不包含上方已出现的字段 */
        // 投资物业
        investmentProperties: 'invProperty',
        // 房屋,产房及设备
        propertyAndEquipment: '',
        // 租赁土地权益
        leaseholdLandAndUseRights: '',
        // 预付土地/租赁款项
        prepaidLandAndLeasePremiums: 'leaseLiabilities',
        // 债权类证券
        debtSecurities: 'dEBTINV',
        // 股权类证券
        equitySecurities: '',
        // 衍生金融资产
        derivativeFinancialAssets: '',
        // 贷款
        loans: '',
        // 其他投资
        otherInvestments: 'otherEquityInvestment',
        // 联营公司权益
        interestsInAssociates: '',
        // 共同控制公司权益
        interestsInJointVentures: '',
        // 商誉
        goodwill: '',
        // 其他无形资产
        otherIntangileAssets: 'intangibleAssets',
        // 应收保险款项
        insuranceReceivables: '',
        // 分保资产
        reinsuranceAssets: '',
        // 应收关连公司款项
        amountDueFromRelatedParties: '',
        // 递延保单获取成本变动
        deferredPolicyAcquisitionCosts: '',
        // 递延税项资产
        deferredTaxAssets: '',
        // 法定存款
        statutoryDeposits: '',
        // 保险准备金
        insuranceFunds: 'generalRiskProvision',
        // 保险保障基金
        insuranceProtectionFund: '',
        // 应付保险款项
        insurancePayables: '',
        // 保户投资合同负债
        investmentContractLiabilities: '',
        // 卖出回购资产
        assetsSoldRepurchase: '',
        // 衍生金融负债
        derivativeFinancialLiabilities: '',
        // 应付关连公司款项
        amountsDueRelatedParties: '',
        // 应付所得税
        currentTaxation: '',
        // 递延税项负债
        deferredTaxLiabilities: '',
        // 保单持有人权益
        policyholdersEquity: ''
      }[oldVal]

      return newVal ? val.replace(oldVal, newVal) : val
    },
    // 将A股值不同的字段统一为港股接口字段值
    formatAVal(val, type = 'reportType') {
      return (
        {
          reportType: {
            12: 'F',
            9: 'Q3',
            6: 'I',
            1: 'Q1'
          },
          currency: {
            142: 'RMB'
          }
        }?.[type]?.[val] ?? val
      )
    },
    async getBalanceStatement() {
      const res = await this.$post(this.$api.f10[this.market] + '/finance/balance', {
        symbol: this.symbol,
        startDate: this.$dayjs().subtract(5, 'year').format('YYYY-MM-DD')
      })
      const reportTypeMap = {
        F: 4,
        Q3: 3,
        I: 2,
        Q1: 1
      }

      let data = res.data?.filter((item) => Boolean(reportTypeMap[this.formatAVal(item.reportType)])) ?? []

      data = data.map((item) => {
        item.sortYear = +this.$dayjs(item.reportDate).format('YYYY')
        item.reportType = this.formatAVal(item.reportType)
        item.currency = this.formatAVal(item.currency, 'currency')
        return item
      })

      this.tableData = data.sort(
        (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
      )
    }
  }
}
</script>

<style lang="scss">
.financial-statements-hk {
}
</style>
